import { render, staticRenderFns } from "./BarcodeSetting.vue?vue&type=template&id=27a11aef&scoped=true&"
import script from "./BarcodeSetting.vue?vue&type=script&lang=js&"
export * from "./BarcodeSetting.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeSetting.vue?vue&type=style&index=0&id=27a11aef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a11aef",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a11aef')) {
      api.createRecord('27a11aef', component.options)
    } else {
      api.reload('27a11aef', component.options)
    }
    module.hot.accept("./BarcodeSetting.vue?vue&type=template&id=27a11aef&scoped=true&", function () {
      api.rerender('27a11aef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/BarcodeSetting.vue"
export default component.exports